export const DAO_CODE = 'PROJECTS' + '_DAO';
